<template>
        <div class="video-choiceBox">
          <div id="tpl-free-tishi" class="playclose" v-show="showMessage">
            <div class="play-fixed"></div>
            <div class="play-in">
                <div class="black-fixed">
                    <div class="play-box">
                        <h4>友情提示<b class="close closebtn" @click="closeMessage()" data-type="fee"></b></h4>
                        <div class="text"><b class="ico two-care"></b><label id="span-tpl-free">该节</label>视频为收费章节,请购买后再进行学习!</div>
                        <div class="button">
                            <a href="javascript:;"  @click="closeMessage()" class="red closebtn">我知道了</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="video-play">
              <div class="video-big">
                <div id="playerContent1"   v-if="isPlay">
                  <iframe ref="mediaframe" id="mediaframe" allowfullscreen="true" allowtransparency="true" scrolling="no" 
                   :src="videoSrc"  width="780" height="440" frameborder="0">
                    </iframe>
                </div>
                <div class="pic" @click="play()" v-if="!isPlay"> 
                    <img :src="'http://img.233.com/wx/img/union/channel/playimg/'+classEname+'.jpg'" > 
                    <a href="javascript:;" class="icon" title="点击播放"></a> <a href="javascript:;" class="txt-logo"> 
                        <img :src="logo" width="255" height="88" alt="" > 
                    </a> 
                </div>
              </div>
            </div>
            <div class="course-list">
              <div class="currse-Lcon">
                <dl>
                  <dt class="teacher-tab clearfix">
                    <a v-for="(v,i) in data.Teachers" :key="i" :class="teacherIndex==i?'curr':''" href="javascript:;" @click="changeTeacherIndex(i)">{{v.Teacher}}<em></em></a>
                  </dt>
                  <dd class="kcstlist hover">
                    <div class="scroll-listBox he330">
                      <div class="nano has-scrollbar">
                        <div class="overthrow nano-content description" tabindex="0" style="right: -10px;">
                          <div class="course-list-con">
                            <dl v-for="(v,i) in data.Teachers[teacherIndex].Chapters" :key="i">
                              <dt class="expanded">{{v.ZjName}}<i></i></dt>
                              <dd> 
                                <template   v-for="(vv,ii) in v.Details">
                                  <template v-if="vv.FreelistenTF">
                                    <a @click="changeDetailIndex(i,ii,vv.FreelistenTF)" :class="detailIndex==ii&&chapterIndex==i?'free-color hover':'free-color'" :key="ii"  href="javascript:;">
                                      <b class="key correct"></b>{{vv.Sort+"、"+vv.Subject}}
                                      <b v-if="vv.FreelistenTF" class="freest">免费</b>
                                    </a>
                                  </template>
                                  <template v-else>
                                    <a @click="changeDetailIndex(i,ii,vv.FreelistenTF)" :class="detailIndex==ii&&chapterIndex==i?'hover':''" :key="ii"  href="javascript:;">
                                      <b class="key correct"></b>{{vv.Sort+"、"+vv.Subject}}
                                    </a>
                                  </template>
                                </template>
                               </dd>
                            </dl>

                          </div>
                        </div>
                        <div class="nano-pane">
                          <div class="nano-slider" style="height: 160px; transform: translate(0px, 0px);"></div>
                        </div>
                      </div>
                    </div>
                    <a href="/course/study?mid=21350" target="_blank" class="st-moreBtn">点击试听更多</a> </dd>
                </dl>
              </div>
              <div class="course-Lbtn btn-redbg"> 
                <span>
                  <a href="javascript:;" @click="scroll(900)">立即报名</a>
                </span>
              </div>
            </div>
          </div>
</template>
<script>

import { getVideoCourse } from '@/request/request.js'
export default {
        name: 'App',
        props: {
            myClassId: Number,
            classEname:String,
            logo:String,
            unionId:String,
            allLoginPlayFlag:[Boolean,Number],
            isLogin:Boolean
        },
    components: {
      
    },
    data() {
        return {
            showMessage:false,
            isPlay:false,
            videoSrc:"",
            data:{},
            teacherIndex:0,
            detailIndex:0,
            chapterIndex:0,
        };
    },
    watch: {
        'myClassId': function(newVal){
          this.teacherIndex=0;
          this.detailIndex=0;
          this.chapterIndex=0;
          getVideoCourse({myClassId:newVal},(res)=>{
            this.data=res.Result;
            if (location.hash.indexOf("jiankanggls") > -1) {
              let { Teachers } = res.Result
              this.data.Teachers = [Teachers.find(item => item.TeacherId === 1062)]
            }
            this.changeVideo();
          });
        }
    },
    mounted(){
      
    },
    created(){
        getVideoCourse({myClassId:this.myClassId},(res)=>{
          this.data=res.Result;
          if (location.hash.indexOf("jiankanggls") > -1) {
            let { Teachers } = res.Result
            this.data.Teachers = [Teachers.find(item => item.TeacherId === 1062)]
          }
          this.changeVideo();
        });
    },
    methods:{
      scroll(num){
        document.documentElement.scrollTop=num;
      },
      closeMessage(){
        this.showMessage=false;
      },
      changeVideo(){
          this.videoSrc="//wx.233.com/search/v1/study/union/mediaplay?width=780&height=495&mid="+
          this.data.YearMyClassId+"&did="+this.data.Teachers[this.teacherIndex]?.Chapters[this.chapterIndex]?.Details[this.detailIndex]?.DCourseId+"&tid="+
          this.data.YearMyClassId+"&did="+this.data.Teachers[this.teacherIndex]?.TeacherId+"&state=1&un="+this.unionId+"&teaser=1"
      },
      changeDetailIndex(i,ii,freelistenTF){
        if(freelistenTF){
            if(this.allLoginPlayFlag){
              if(!this.isLogin){
                  window.location.href="/uc/login?redirecturl="+ encodeURIComponent(window.location.href);
                  return;
              }
            }else{
              if(!this.isLogin&&(ii>0||i>0)){
                  window.location.href="/uc/login?redirecturl="+ encodeURIComponent(window.location.href);
                  return;
              }
            }
        }else{
          this.showMessage=true;
          return;
        }
        this.chapterIndex=i;
        this.detailIndex=ii;
        this.changeVideo();
        this.play();
      },
      changeTeacherIndex(i){
        this.teacherIndex=i;
      },
        play(){
            if(this.allLoginPlayFlag){
              if(!this.isLogin){
                  window.location.href="/uc/login?redirecturl="+ encodeURIComponent(window.location.href);
                  return;
              }
            }
            else{
              if(!this.isLogin&&(this.chapterIndex>0||this.detailIndex>0)){
                  window.location.href="/uc/login?redirecturl="+ encodeURIComponent(window.location.href);
                  return;
              }
            }
            this.isPlay=true;
        },
    },
}
</script>